export default function getValueIgnoreCase(object, key) {
    let keysLowerCase = Object.keys(object).map(function(keyName) {
      keyName = keyName.toLowerCase();
      return keyName;
    });
    return Object.values(object)[keysLowerCase.indexOf(key.toLowerCase())];
  }